import Tabs from './utils/Tabs.js';
import menu      from './utils/menu.js';
import DropPanel from './components/DropPanel.js';
import modal     from './utils/modal.js';
import Anim from './components/Anim.js';
import cookies from './utils/cookies.js';



// Init
function init() {
    //Tabs
    const tabContainer = document.querySelectorAll('[data-tab="tabs"]');
    tabContainer.forEach((tabContainer) => new Tabs(tabContainer));

    menu();

    // Dropdown
    new DropPanel();

    modal();

    Anim();

    cookies();


}

(function () {
	init();
}());
